import React, {Component} from 'react';
import {Checkbox, FormControl, FormGroup, Radio, HelpBlock, DropdownButton, MenuItem} from 'react-bootstrap';
import {connect} from 'react-redux';
import $ from 'jquery';
import ReactDOM from 'react-dom';
import { Trans,withTranslation} from 'react-i18next';

import './Thanks.css';
import nextArr from '../assets/images/next-arrow.svg';
import moment from 'moment';

import {dynamicRender, renderShare, renderShareProcess, submitOptin, updateVBPInner, webhookRegister} from "../actions/AuthActions";
import PlayersStatistics from '../components/PlayersStatistics';
import {trackVote, trackOptin} from "../actions/TrackingActions";
import { getUrlWord, isValidJSON, returnValueIfNotEmpty, setCustomInputStyling } from "../util/helpers/Helpers";
import Footer from "./Footer";
import IntlTelInput from 'react-intl-tel-input';
import 'react-intl-tel-input/dist/main.css';
import {
  EmailIcon,
  FacebookIcon,
  FacebookMessengerIcon,
  PinterestIcon,
  LinkedinIcon,
  PocketIcon,
  RedditIcon,
  TumblrIcon, 
  TwitterIcon,
  WhatsappIcon,
  EmailShareButton,
  FacebookShareButton,
  FacebookMessengerShareButton,
  PinterestShareButton,
  PocketShareButton,
  RedditShareButton,
  TumblrShareButton,
  TwitterShareButton,
  WhatsappShareButton,
  LinkedinShareButton
  } from "react-share";
  import { FaSms, FaBuffer, FaWordpress, FaFlipboard,FaSkype} from "react-icons/fa";
  import { IoMdArrowDropleft,IoMdArrowDropright} from 'react-icons/io';
  import CustomShare from '../components/custom-share';
  import { FACEBOOK_APP_ID } from '../util/Constants';



class Thanks extends Component {

  componentDidMount() {

    const omnihubPrefil = localStorage.getItem('omnihubPrefilData');
    console.log('omni-thanks', omnihubPrefil);
    if (omnihubPrefil && isValidJSON(omnihubPrefil)) {
      let omnihubData = JSON.parse(omnihubPrefil);
      console.log('ohb-data-receive', omnihubData);
      if (omnihubData) {
        let optinState = this.state.optin;
        this.setState({
          ...this.state,
          optin: {
            ...optinState,
            firstname: returnValueIfNotEmpty(omnihubData.firstname),
            lastname: returnValueIfNotEmpty(omnihubData.lastname),
            email: returnValueIfNotEmpty(omnihubData.email),
            address: returnValueIfNotEmpty(omnihubData.address),
            postcode: returnValueIfNotEmpty(omnihubData.postcode),
            state: returnValueIfNotEmpty(omnihubData.state),
            dob: returnValueIfNotEmpty(omnihubData.dob)
          }
        });
      }
    }

    const optinFinished = localStorage.getItem('optinFinished');

    if (optinFinished) {
      this.setState({ shouldRedirect: true });
      // this.props.history.push('/' + formedUrl);
    }

  }

  constructor(props) {

    super(props);
    this.socialShareRef = React.createRef();

    this.handleChange = this.handleChange.bind(this);
    this.handleChangeOptinOther = this.handleChangeOptinOther.bind(this);
    this.handleChangeOptinOtherComm = this.handleChangeOptinOtherComm.bind(this);
    this.handleSelectOptinOtherOption = this.handleSelectOptinOtherOption.bind(this);
    this.handleSelectOptinOtherOptionSingle = this.handleSelectOptinOtherOptionSingle.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleAcceptTnc = this.handleAcceptTnc.bind(this);
    this.handleChangeShare =  this.handleChangeShare.bind(this);

    this.state = {
      shouldRedirect: false,
      twitterShare: 'https://s3-ap-southeast-2.amazonaws.com/bulldogs-web/staging/t.htm',
      facebookShare: 'https://s3-ap-southeast-2.amazonaws.com/bulldogs-web/staging/f.htm',
      charLengthCustom: 'Characters Left: 2000/2000',
      charLengthCustomComm: [],
      optin: {
        firstname: '',
        lastname: '',
        email: '',
        mobile:  {
          countryData: {},
          number: '',
          status: false,
          value:''
        },
        address: '',
        postcode: '',
        state: '',
        other01: '',
        other02: '',
        other03: '',
        other04: '',
        other05: '',
        other06: '',
        other07: '',
        other08: '',
        other09: '',
        other10: '',
        tnc: false,
        marketing: false,
        others: [],
        dob: '',
        customDesc: '',
        confirmAdult: false
      },
      errStates: {
        firstname: false,
        lastname: false,
        email: false,
        mobile: false,
        address: false,
        postcode: false,
        state: false,
        other01: false,
        other02: false,
        other03: false,
        other04: false,
        other05: false,
        other06: false,
        other07: false,
        other08: false,
        other09: false,
        other10: false,
        tnc: false,
        dob: false,
        customDesc: false,
        confirmAdult: false
      }
    }
    this.preferredCountries = ['au','gb','us','br','ca','cn','de','in','id','my','nl','nz','pt','sg','es','th','vn','kr'];
  }

  sendParentScrollMessage = (e) => {
    var domRect = e.target.getBoundingClientRect();
    if (window.self !== window.top) {
      window.parent.postMessage(`benchvoteScroll-${domRect.top}`,
        'http://www.westernbulldogs.com.au');
    }
  }

  // renderStats = (stats) => {
  //
  //     let ret = stats.map(p => {
  //         return (<div className='pl'>
  //             <img src={p.headshotSmall}/>
  //             <div >{Math.floor(p.percent)}%</div >
  //         </div >);
  //     });
  //
  //     return ret;
  // }

  handleAcceptTnc = () => {
    let newState = {...this.state.optin};
    newState.tnc = !newState.tnc;
    this.setState({
      ...this.state,
      optin: newState
    });
  }

  handleAcceptMarketing = () => {
    let newState = {...this.state.optin};
    newState.marketing = !newState.marketing;
    this.setState({
      ...this.state,
      optin: newState
    });
  }

  selectMembership = (value) => {
    let newState = {...this.state.optin};
    newState.member = value;
    this.setState({
      ...this.state,
      optin: newState
    });
  }

  memberYes = (e) => {
    let newState = {...this.state.optin};
    newState.memberYes = e.target.value;
    this.setState({
      ...this.state,
      optin: newState
    });
  }

  memberNo = (value) => {
    let newState = {...this.state.optin};
    newState.memberNo = value;
    this.setState({
      ...this.state,
      optin: newState
    });
  }

  handleChange = (field, e) => {
    let newState = {...this.state.optin};
    newState[field] = e.target.value;
    this.setState({
      ...this.state,
      optin: newState
    });
  }

  handleAcceptConfirmAdult = () => {
    let newState = {...this.state.optin};
    newState.confirmAdult = !newState.confirmAdult;
    this.setState({
      ...this.state,
      optin: newState
    });
  }

  handleCustomDescriptionChange = (e) => {
    const {t} = this.props;
    let optin = this.state.optin;
    optin[e.target.name] = e.target.value;
    this.setState({
      optin
    });

    var maxLength = 2000;
    if (e.target.value.length > maxLength) {
      this.state.charLengthCustom =
        `${t('character_left')}: ` + e.target.value.substring(0, maxLength) + '/2000';
    } else {
      this.state.charLengthCustom =
      `${t('character_left')}: ` + (maxLength - e.target.value.length) + '/2000';
    }
  }

  handleSelectOptinOtherOptionSingle = (idOptinOther, ooo, e) => {
    const optin = {
      ...this.state.optin
    };
    if (!optin.others[idOptinOther]) {
      optin.others[idOptinOther] = {};
      optin.others[idOptinOther].selectedValues = [];
    }
    optin.others[idOptinOther].selectedValues = [ooo.id];
    this.setState({optin});
  }

  handleSelectOptinOtherOption = (idOptinOther, ooo, e) => {
    const optin = {
      ...this.state.optin
    };
    if (!optin.others[idOptinOther]) {
      optin.others[idOptinOther] = {};
      optin.others[idOptinOther].selectedValues = [];
    }
    if (e.target.checked) {
      optin.others[idOptinOther].selectedValues.push(ooo.id);
    } else {
      optin.others[idOptinOther].selectedValues = optin.others[idOptinOther]
        .selectedValues.filter(o2 => o2 !== ooo.id);
    }
    this.setState({optin});
  }

  handleChangeOptinOther = (idOptinOther, e) => {
    const optin = {
      ...this.state.optin
    };
    if (!optin.others[idOptinOther]) {
      optin.others[idOptinOther] = {};
    }
    optin.others[idOptinOther].value = e.target.value;
    this.setState({optin});
  }

  handleChangeOptinOtherComm = (idOptinOther, e) => {
    const {t} = this.props;
    const optin = {
      ...this.state.optin
    };
    if (!optin.others[idOptinOther]) {
      optin.others[idOptinOther] = {};
    }
    optin.others[idOptinOther].value = e.target.value;
    this.setState({optin});

    var maxLength = 2000;
    if (e.target.value.length > maxLength) {
      this.state.charLengthCustomComm[idOptinOther] =
        `${t('character_left')}: ` + e.target.value.substring(0, maxLength) + '/2000';
    } else {
      this.state.charLengthCustomComm[idOptinOther] =
      `${t('character_left')}: ` + (maxLength - e.target.value.length) + '/2000';
    }
  }

  validateEmail = (email) => {
    return /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(String(email).toLowerCase());
  }

  validateDob(dob) {
    var birthday = moment(dob);
    return birthday.isValid() && birthday.isBefore();
  }

  triggerVBooster = (vBooster) => {

    if (vBooster.ctaLink && vBooster.ctaLink != "") {
      window.open(vBooster.ctaLink, '_blank');
    }

    let comp = this.props.competition;

    console.log('optin-data', this.props);

    if (comp) {

      let idOptin = localStorage.getItem(`idOptin-${comp.id}`);

      if (vBooster.idCompetition && vBooster.id && idOptin) {
        var params = {
          idComp: vBooster.idCompetition,
          idCompVB: vBooster.id,
          idOptin
        }

        this.props.dispatch(
          updateVBPInner(
            this.props.competition.id,
            params,
            this.props.dispatch
          )
        );

        // const cookies = new Cookies();
        // cookies.set('vBEntries-' + vBooster.idCompetition, vBEntriesExisting);

        // var vBEntries = cookies.get('vBEntries-' + vBooster.idCompetition);

      }
    }

    // if (vBooster.idCompetition && vBooster.id && idOptin) {
    //   var params = {
    //     idComp: vBooster.idCompetition,
    //     idCompVB: vBooster.id,
    //     idOptin: idOptin
    //   }
    //   CompetitionService.updateVBPInner(params,
    //     function (response) {
    //       console.log('response-v-booster', response);
    //       _.forEach($scope.competition.viralBoosters, function (vB, vBKey) {
    //         if (vB && vB.id == vBooster.id) {
    //           $scope.competition.viralBoosters[vBKey].pointsAdded = true;
    //           $scope.pointsSoFar = $scope.pointsSoFar + vBooster.points;

    //           var vBEntries = $cookies.getObject('vBEntries-' + vBooster.idCompetition);
    //           var vBEntriesExisting = [];
    //           if (vBEntries && vBEntries.split(",")) {
    //             vBEntriesExisting = vBEntries.split(",");
    //             if(!vBEntries.includes(vBooster.id.toString())) {
    //               vBEntriesExisting.push(vBooster.id.toString());
    //             }
    //             vBEntriesExisting.toString();
    //           }
    //           $cookies.putObject('vBEntries-' + vBooster.idCompetition, vBEntriesExisting);
    //         }
    //       });
    //       console.log('response-v-booster-1', vBooster);
    //     },
    //     function (err) {
    //       console.log(err);
    //     });
    // }

  }

  handleSubmit = () => {

    const {
      firstname, lastname, email, mobile, address, state, postcode, tnc, marketing,
      other01, other02, other03, other04, other05, other06, other07, other08, other09, other10, others,
      member, memberYes, memberNo, dob, customDesc, confirmAdult
    } = this.state.optin;
    const idCompetition = this.props.competition.id;
    const idVote = this.props.vote.payload.idVote;

    const {
      optinFirstname, optinLastname, optinPhone, optinEmail, optinAddress,
      optinPostcode, optinState, optinTncs, optinOther, optinOther02, optinOther03, optinOther04, optinOther05,
      optinOther06, optinOther07, optinOther08, optinOther09, optinOther10, optinDob, optinCustomDesc, optinConfirmAdult
    } = this.props.competition

    const {
      flakeId
    } = this.props.tracking;

    // webhook data
    let customFields = {};
    const otherData = this.props.competition.otherOptins
      .filter(o => !o.deleted).map(oo => {
        if (!oo.deleted) {
          if (oo.type === 'text' || oo.type === 'comment') {

            // webhooks data
            if (others[oo.id]) {
              customFields[oo.copy] = others[oo.id].value;
            }

            return {
              id: oo.id,
              type: oo.type,
              value: others[oo.id] ? others[oo.id].value : ''
            };
          } else if (oo.type === 'checkbox' || oo.type === 'dropdown' || oo.type === 'radio') {

            // webhooks data
            if (oo.type === 'checkbox') {
              let newVal = [];
              oo.options.forEach((ooo, index) => {
                if (others && others[oo.id] && others[oo.id].selectedValues.includes(ooo.id)) {
                  newVal.push(ooo.copy);
                }
              });
              if(newVal.length > 0){
                customFields[oo.copy] =  newVal.join(',');
              }
            } else {
              oo.options.forEach((ooo, index) => {
                if (others && others[oo.id] && (others[oo.id].selectedValues.includes(`${ooo.id}`)
                  || others[oo.id].selectedValues.includes(ooo.id))) {
                  customFields[oo.copy] =  ooo.copy;
                }
              });
            }

            return {
              id: oo.id,
              type: oo.type,
              values: others[oo.id] ? others[oo.id].selectedValues : []
            };
          }
        }
      });

    let es = {
      firstname: optinFirstname && !firstname,
      lastname: optinLastname && !lastname,
      email: optinEmail && !this.validateEmail(email),
      mobile: optinPhone && (!mobile || isNaN(mobile.value) || !mobile.status),
      address: optinAddress && !address,
      state: optinState && !state,
      postcode: optinPostcode && (!postcode || isNaN(postcode)),
      tnc: optinTncs && !tnc,
      other01: optinOther && !other01,
      other02: optinOther02 && !other02,
      other03: optinOther03 && !other03,
      other04: optinOther04 && !other04,
      other05: optinOther05 && !other05,
      other06: optinOther06 && !other06,
      other07: optinOther07 && !other07,
      other08: optinOther08 && !other08,
      other09: optinOther09 && !other09,
      other10: optinOther10 && !other10,
      member,
      memberYes,
      memberNo,
      dob: optinDob && !this.validateDob(dob),
      confirmAdult: optinConfirmAdult && !confirmAdult,
      customMandatoryOptin: false
    }

    const otherOptins = this.props.competition.otherOptins;

    if (otherOptins && otherOptins.length > 0) {
        otherOptins.forEach((oo, key) => {
            if (otherOptins.hasOwnProperty(key) && !otherOptins[key].deleted
                && otherOptins[key].mandatory) {
                switch (otherOptins[key].type) {
                    case 'text':
                    case 'date':
                    case 'comment':
                        if (!others[otherOptins[key].id] || !others[otherOptins[key].id].hasOwnProperty('value')
                            || others[otherOptins[key].id].value == null || !others[otherOptins[key].id].value
                            || others[otherOptins[key].id].value.trim() == "") {
                            es.customMandatoryOptin = true;
                            otherOptins[key].hasError = true;
                        } else {
                            otherOptins[key].hasError = false;
                        }
                        break;
                    case 'checkbox':
                    case 'dropdown':
                    case 'radio':
                        if (!others[otherOptins[key].id] || !others[otherOptins[key].id].hasOwnProperty('selectedValues')
                            || others[otherOptins[key].id].selectedValues.length < 1 || others[otherOptins[key].id].selectedValues[0] == "") {
                            es.customMandatoryOptin = true;
                            otherOptins[key].hasError = true;
                        } else {
                            otherOptins[key].hasError = false;
                        }
                        break;
                }
            }
        });
    }

    window.scrollTo(0, 0);

    if (es.firstname || es.lastname || es.email || es.mobile || es.address
      || es.state || es.postcode || es.tnc || es.other01 || es.other02 || es.other03 || es.other04 || es.other05
      || es.other06 || es.other07 || es.other08 || es.other09 || es.other10 || es.dob || es.confirmAdult || es.customMandatoryOptin) {

      this.setState({
        ...this.state,
        errStates: es
      });

    } else {

      this.props.dispatch(submitOptin(
        {
          firstname, lastname, email,
          mobile:mobile.value?(mobile.number).replace(/\s+/g, ''):'', address, state,
          postcode, tnc, optin: marketing, other01,
          other02, other03, other04, other05, other06, other07, other08, other09, other10,
          member, memberYes, memberNo,
          dob, confirmAdult, customDesc,
          idCompetition, idVote, trackingFlakeId: flakeId, other: otherData
        },
        this.props.dispatch,
        getUrlWord(this.props.match.url, this.props.location.hash)
      ));

        if (this.props && this.props.competition && this.props.competition.webhooks.find(wh => wh.type === 'optinSent')) {

          let webhookData = {
            hookType:'optinSent',
            firstname,
            lastname,
            email,
            mobile: mobile.value ? (mobile.number).replace(/\s+/g, '') : '',
            address,
            state,
            postcode,
            tnc,
            optin: marketing,
            dob,
            customDesc,
            confirmAdult,
            idCompetition
          };

          if (otherData) {
            webhookData.otherData = otherData;
          }

          if (customFields) {
            webhookData.customFields = customFields;
          }

          console.log("Optin webhook data", webhookData);

          this.props.dispatch(webhookRegister(
            webhookData,
            this.props.dispatch
          ));
        }
      

        this.setState({
          ...this.state,
          errStates: es
        });
      }
  }

  isSocialNetworkEnabledForCompetition = (socialNetworkId) => {

    if (this.props.competition.socialNetworksEnabled) {
      return !!this.props.competition.socialNetworksEnabled.find(sn => sn.id === socialNetworkId);
      // for (var i = 0; i < this.props.competition.socialNetworksEnabled.length; i++) {
      //   var tempSocialNetwork = this.props.competition.socialNetworks[i];
      //   if (tempSocialNetwork.id === socialNetworkId) {
      //     // return tempSocialNetwork.isActiveOnCompetition;
      //     return true;
      //   }
      // }
    }
    return false;
  };

  handleTwitterShare = (competition, vote) => {

    // var shareText = competition.socialSharingTextDescription;
    // var twitterShareUrl = vote.shareContentUrlBySocialNetworkId[2];
    // window.open('http://www.twitter.com/intent/tweet?url=' +
    //   encodeURIComponent(twitterShareUrl) + '&text=' + encodeURIComponent(shareText),
    //   'twitter-share-dialog', 'width=626,height=436'
    // );

    if (this.props.vote && this.props.vote.share && this.props.vote.share.data
      && this.props.vote.share.data.length > 0) {
      renderShareProcess(this.props.vote.share.data, 2);
    }
    else {
      const renderData = {
        idCompetition: competition.id,
        idVote: vote.idVote
      };

      this.props.dispatch(
        renderShare(renderData, this.props.dispatch, 2)
      );
    }
  };

  handleFacebookShare = (competition, vote) => {

    // var facebookShareUrl = vote.shareContentUrlBySocialNetworkId[1];
    // window.open('https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(facebookShareUrl),
    //   'facebook-share-dialog', 'width=626,height=436'
    // );

    if (this.props.vote && this.props.vote.share && this.props.vote.share.data
      && this.props.vote.share.data.length > 0) {
      renderShareProcess(this.props.vote.share.data, 1);
    }
    else {
      const renderData = {
        idCompetition: competition.id,
        idVote: vote.idVote
      };

      this.props.dispatch(
        renderShare(renderData, this.props.dispatch, 1)
      );
    }
  };

  componentDidUpdate(prevProps) {
    if (this.props.vote.payload.idVote && !prevProps.vote.payload.idVote) {
      const {idVote} = this.props.vote.payload;
      const {flakeId} = this.props.tracking;

      // process dynamic image render
      const dynamicRenderUrl = localStorage.getItem('dynamicRenderUrl');
      if (this.props.competition && this.props.competition) {
        if (this.props.competition.dynamicRenderBackgroundImageUrl && this.props.competition.dynamicRenderBackgroundImageUrl !== ''
          && (!dynamicRenderUrl || dynamicRenderUrl == null)) {
          const dynamicRenderInput = {
            'idCompetition': this.props.competition.id,
            'idVote': idVote,
            "ipAddress": "0.0.0.0",
            "referrer": window.location.protocol + "//" + window.location.host
          }
          this.props.dispatch(dynamicRender(dynamicRenderInput, this.props.dispatch));
        }
      }

      this.props.dispatch(trackVote(this.props.competition.id, idVote.toString(10), flakeId, this.props.dispatch));
    }
    if (this.props.optin.payload.idOptin && !prevProps.optin.payload.idOptin) {
      const {idVote} = this.props.vote.payload;
      const {idOptin} = this.props.optin.payload;
      const {flakeId} = this.props.tracking;
      this.props.dispatch(trackOptin(this.props.competition.id, idVote.toString(10),
        idOptin.toString(10), flakeId, this.props.dispatch));
    }
    const submitted = this.props.optin.submitted;
    if (!submitted && this.props.competition && this.props.competition.id > 0 && !window.codeInjectedForDataCapturePage) {

      const codeSamples = this.props.competition.codeSnippetsForInjection || [];
      for (let i = 0; i < codeSamples.length; i++) {
        if (codeSamples[i].page === 'global' && codeSamples[i].htmlTagName && codeSamples[i].codeToBeInjected) {
          $(codeSamples[i].htmlTagName).append(codeSamples[i].codeToBeInjected);
        } else if (codeSamples[i].page === 'dataCapture' && codeSamples[i].codeToBeInjected) {
          $(ReactDOM.findDOMNode(this)).append(codeSamples[i].codeToBeInjected);
        }
      }
      window.codeInjectedForDataCapturePage = true;
    }
    if (submitted && this.props.competition && this.props.competition.id > 0 && !window.codeInjectedForConfirmationPage) {

      const codeSamples = this.props.competition.codeSnippetsForInjection || [];
      for (let i = 0; i < codeSamples.length; i++) {
        if (codeSamples[i].page === 'global' && codeSamples[i].htmlTagName && codeSamples[i].codeToBeInjected) {
          $(codeSamples[i].htmlTagName).append(codeSamples[i].codeToBeInjected);
        } else if (codeSamples[i].page === 'confirmation' && codeSamples[i].codeToBeInjected) {
          $(ReactDOM.findDOMNode(this)).append(codeSamples[i].codeToBeInjected);
        }
      }
      window.codeInjectedForConfirmationPage = true;
    }
  }

  handleMobileNumber = (event)=>{
    console.log(event)
    let newState = {...this.state.optin};
    newState['mobile'] = event;
    this.setState({
        ...this.state,
        optin: newState
    });
  }

  renderCustomFields = (comp, other01, other02, other03, other04, other05, other06, other07, other08, other09, other10, errors) => {
    return (
      <div>
        {comp.optinOther ? (
          <div className='optin-row'>
            <div className='optin-col'>
              <FormControl
                type="text"
                value={other01}
                placeholder={comp.optinOtherLabel}
                onFocus={this.sendParentScrollMessage}
                onChange={(e) => this.handleChange('other01', e)}
              />
              {errors.other01 ? (
                <HelpBlock>{comp.optinOtherLabel} <Trans i18nKey="is_invalid" /></HelpBlock>
              ) : null}
            </div>
          </div>
        ) : null}

        {comp.optinOther02 ? (
          <div className='optin-row'>
            <div className='optin-col'>
              <FormControl
                type="text"
                value={other02}
                placeholder={comp.optinOtherLabel02}
                onFocus={this.sendParentScrollMessage}
                onChange={(e) => this.handleChange('other02', e)}
              />
              {errors.other02 ? (
                <HelpBlock>{comp.optinOtherLabel02} <Trans i18nKey="is_invalid" /></HelpBlock>
              ) : null}
            </div>
          </div>
        ) : null}

        {comp.optinOther03 ? (
          <div className='optin-row'>
            <div className='optin-col'>
              <FormControl
                type="text"
                value={other03}
                placeholder={comp.optinOtherLabel03}
                onFocus={this.sendParentScrollMessage}
                onChange={(e) => this.handleChange('other03', e)}
              />
              {errors.other03 ? (
                <HelpBlock>{comp.optinOtherLabel03} <Trans i18nKey="is_invalid" />.</HelpBlock>
              ) : null}
            </div>
          </div>
        ) : null}

        {comp.optinOther04 ? (
          <div className='optin-row'>
            <div className='optin-col'>
              <FormControl
                type="text"
                value={other04}
                placeholder={comp.optinOtherLabel04}
                onFocus={this.sendParentScrollMessage}
                onChange={(e) => this.handleChange('other04', e)}
              />
              {errors.other04 ? (
                <HelpBlock>{comp.optinOtherLabel04} <Trans i18nKey="is_invalid" /></HelpBlock>
              ) : null}
            </div>
          </div>
        ) : null}

        {comp.optinOther05 ? (
          <div className='optin-row'>
            <div className='optin-col'>
              <FormControl
                type="text"
                value={other05}
                placeholder={comp.optinOtherLabel05}
                onFocus={this.sendParentScrollMessage}
                onChange={(e) => this.handleChange('other05', e)}
              />
              {errors.other05 ? (
                <HelpBlock>{comp.optinOtherLabel05} <Trans i18nKey="is_invalid" /></HelpBlock>
              ) : null}
            </div>
          </div>
        ) : null}


        {comp.optinOther06 ? (
          <div className='optin-row'>
            <div className='optin-col'>
              <FormControl
                type="text"
                value={other06}
                placeholder={comp.optinOtherLabel06}
                onFocus={this.sendParentScrollMessage}
                onChange={(e) => this.handleChange('other06', e)}
              />
              {errors.other06 ? (
                <HelpBlock>{comp.optinOtherLabel06} <Trans i18nKey="is_invalid" /></HelpBlock>
              ) : null}
            </div>
          </div>
        ) : null}

        {comp.optinOther07 ? (
          <div className='optin-row'>
            <div className='optin-col'>
              <FormControl
                type="text"
                value={other07}
                placeholder={comp.optinOtherLabel07}
                onFocus={this.sendParentScrollMessage}
                onChange={(e) => this.handleChange('other07', e)}
              />
              {errors.other07 ? (
                <HelpBlock>{comp.optinOtherLabel07} <Trans i18nKey="is_invalid" /></HelpBlock>
              ) : null}
            </div>
          </div>
        ) : null}

        {comp.optinOther08 ? (
          <div className='optin-row'>
            <div className='optin-col'>
              <FormControl
                type="text"
                value={other08}
                placeholder={comp.optinOtherLabel08}
                onFocus={this.sendParentScrollMessage}
                onChange={(e) => this.handleChange('other08', e)}
              />
              {errors.other08 ? (
                <HelpBlock>{comp.optinOtherLabel08} <Trans i18nKey="is_invalid" /></HelpBlock>
              ) : null}
            </div>
          </div>
        ) : null}

        {comp.optinOther09 ? (
          <div className='optin-row'>
            <div className='optin-col'>
              <FormControl
                type="text"
                value={other09}
                placeholder={comp.optinOtherLabel09}
                onFocus={this.sendParentScrollMessage}
                onChange={(e) => this.handleChange('other09', e)}
              />
              {errors.other09 ? (
                <HelpBlock>{comp.optinOtherLabel09} <Trans i18nKey="is_invalid" /></HelpBlock>
              ) : null}
            </div>
          </div>
        ) : null}

        {comp.optinOther10 ? (
          <div className='optin-row'>
            <div className='optin-col'>
              <FormControl
                type="text"
                value={other10}
                placeholder={comp.optinOtherLabel10}
                onFocus={this.sendParentScrollMessage}
                onChange={(e) => this.handleChange('other10', e)}
              />
              {errors.other10 ? (
                <HelpBlock>{comp.optinOtherLabel10} <Trans i18nKey="is_invalid" /></HelpBlock>
              ) : null}
            </div>
          </div>
        ) : null}
      </div>
    );
  };

  handleChangeShare = (state) =>{
    const scrollRef = this.socialShareRef.current
    const currentPosition =scrollRef.scrollLeft;
    const position =  window.innerWidth > 650?50:73;
    let scrollPosition = state === 'previous'?Math.round(((currentPosition - position)/position)*position):Math.round(((currentPosition + position)/position)*position)
    scrollRef.scrollLeft = scrollPosition;
  }

  renderCustomFieldsActual = (oo, others, otherIndex, config, t) => {
    switch (oo.type) {
      case "text":
        return (
          <div className="optin-col">
            <FormControl
              type="text"
              value={
                (others[oo.id] && others[oo.id].value) || ""
              }
              placeholder={oo.copy}
              onFocus={this.sendParentScrollMessage}
              onChange={e =>
                this.handleChangeOptinOther(oo.id, e)
              }
            />
          </div>
        );
      case "comment":
        return (
          <div className="optin-col">
            <FormControl
              rows="4"
              componentClass="textarea"
              className='textarea'
              value={
                (others[oo.id] && others[oo.id].value) || ""
              }
              placeholder={oo.copy}
              onFocus={this.sendParentScrollMessage}
              onChange={e =>
                this.handleChangeOptinOtherComm(oo.id, e)
              }
              maxLength='2000'
            />
            <div style={{ marginTop: 5, color: config.primaryColor }}>{this.state.charLengthCustomComm[oo.id]
                ? this.state.charLengthCustomComm[oo.id] : this.state.charLengthCustom}</div>
          </div>
        );
      case "checkbox":
        return (
          <div className="optin-col text-left">
            <div
              class="fieldLabel"
              style={{ color: config.primaryColor }}
            >
              {oo.copy}
            </div>
            {oo.options
              .filter(o => !o.deleted)
              .map((ooo, index) => (
                <Checkbox
                  id={`checkGroup${otherIndex}${index}`}
                  className="custom-control custom-checkbox custom-control-inline"
                  onClick={e =>
                    this.handleSelectOptinOtherOption(
                      oo.id,
                      ooo,
                      e
                    )
                  }
                >
                  <label
                    style={{ color: config.primaryColor }}
                    class="custom-control-label"
                    for={`checkGroup${otherIndex}${index}`}
                    dangerouslySetInnerHTML={{
                      __html: ooo.copy
                    }}
                  />
                </Checkbox>
              ))}
          </div>
        );
      case "dropdown":
        return (
          <div className="optin-col text-left">
            <div
              class="fieldLabel"
              style={{ color: config.primaryColor }}
            >
              {oo.copy}
            </div>
            <DropdownButton
              title={
                others[oo.id] && others[oo.id].selectedValues
                  ? oo.options
                    .filter(o => !o.deleted)
                    .find(
                      ooo =>
                        others[oo.id].selectedValues[0] ===
                        ooo.id
                    ).copy
                  : t("select_an_option")
              }
            >
              {oo.options
                .filter(o => !o.deleted)
                .map(ooo => (
                  <MenuItem
                    onClick={e =>
                      this.handleSelectOptinOtherOptionSingle(
                        oo.id,
                        ooo,
                        e
                      )
                    }
                  >
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ooo.copy
                      }}
                    />
                  </MenuItem>
                ))}
            </DropdownButton>
          </div>
        );
      case "radio":
        return (
          <div className="optin-col text-left">
            <div
              class="fieldLabel"
              style={{ color: config.primaryColor }}
            >
              {oo.copy}
            </div>
            {oo.options
              .filter(o => !o.deleted)
              .map((ooo, index) => (
                <Radio
                  id={`radioGroup${otherIndex}${index}`}
                  className="custom-control custom-radio custom-control-inline"
                  name={`radioGroup${oo.id}`}
                  inline
                  onClick={e =>
                    this.handleSelectOptinOtherOptionSingle(
                      oo.id,
                      ooo,
                      e
                    )
                  }
                >
                  <label
                    style={{ color: config.primaryColor }}
                    class="custom-control-label"
                    for={`radioGroup${otherIndex}${index}`}
                    dangerouslySetInnerHTML={{
                      __html: ooo.copy
                    }}
                  />
                </Radio>
              ))}
          </div>
        );
    }
  }

  render() {
    const {t} = this.props;
    const comp = this.props.competition;

    if (this.state.shouldRedirect) {
      const seoUrl = localStorage.getItem('seoUrl');
      console.log('formed', seoUrl);
      const allowMultiUserEntry = localStorage.getItem('allowMultiUserEntry');
      console.log('multi user', allowMultiUserEntry);
      if (seoUrl != 'undefined' && allowMultiUserEntry != 'undefined'
        && allowMultiUserEntry) {
        console.log('redirecting');
        localStorage.removeItem('seoUrl');
        localStorage.removeItem('optinFinished');
        localStorage.removeItem('allowMultiUserEntry');
        localStorage.removeItem('dynamicRenderUrl');
        window.location.replace(seoUrl);
        return false;
        // return <Redirect to={formedUrl} />;
      }
    }

    if (comp.allowMultiUserEntry) {
      localStorage.setItem('allowMultiUserEntry', comp.allowMultiUserEntry);
    }

    const socialShareTitle = comp.shareEnabled && comp.socialSharingTextTitle? comp.socialSharingTextTitle: comp.detail?(comp.detail).replace(/<[^>]*>/g,"").replace(/\\s+/g, " ").trim():'';
    const socialShareUrl = comp.seoUrl && comp.seoUrl != '' ? comp.seoUrl :`${comp.webapp}#${comp.hash}`;
    if (socialShareUrl && socialShareUrl != 'undefined#undefined') {
      localStorage.setItem('seoUrl', socialShareUrl);
    }
    const socialShareDescription =  comp.shareEnabled && comp.socialSharingTextDescription?comp.socialSharingTextDescription:comp.description?(comp.description).replace(/<[^>]*>/g,"").replace(/\\s+/g, " ").trim():'';
    const socialShareMedia =  comp.shareEnabled && comp.socialSharingBackgroundImageUrl?comp.socialSharingBackgroundImageUrl:(comp.logoBg && comp.logoBg.file)?(comp.logoBg.file):'';

    const {
      firstname, lastname, email, mobile, address, state, postcode, tnc, marketing,
      other: other01, other02, other03, other04, other05, other06, other07, other08, other09, other10,
      member, memberNo, others, dob, customDesc, confirmAdult
    } = this.state.optin;

    // use optin only if lead data capture is enabled
    let {submitting, submitted} = (!!comp.dataCaptureEnabled) ? this.props.optin : this.props.vote;

    // process dynamic image render
    let {dynamicSubmitting} = this.props.dynamicRender ? this.props.dynamicRender : this.props;
    let dynamicRenderUrl = localStorage.getItem('dynamicRenderUrl');

    const errors = this.state.errStates;

    // enable anyField only if lead data capture is enabled
    let anyField = !!comp.dataCaptureEnabled && (!!comp.optinFirstname || !!comp.optinLastname || !!comp.optinPhone || !!comp.optinEmail || !!comp.optinAddress || !!comp.optinPostcode ||
      !!comp.optinState || !!comp.optinTncs || !!comp.optinOther || !!comp.optinOther02 || !!comp.optinOther03 || !!comp.optinOther04 || !!comp.optinOther05
      || !!comp.optinOther06 || !!comp.optinOther07 || !!comp.optinOther08 || !!comp.optinOther09 || !!comp.optinOther10 || !!comp.optinDob || !! comp.optinCustomDesc
      || !!comp.optinConfirmAdult);

    if (!comp || comp.id === 0) {
      return null;
    }

    let noBorderRadius = (comp && comp.defaultShape == 2);

    let leadCaptureFields = [
      {
        id: 'optinFirstname',
        value: firstname,
        model: 'firstname',
        placeholder: 'first_name',
        type: 'text',
        error: {
          field: 'firstname',
          message: 'err_first_name'
        }
      },
      {
        id: 'optinLastname',
        value: lastname,
        model: 'lastname',
        placeholder: 'last_name',
        type: 'text',
        error: {
          field: 'lastname',
          message: 'err_last_name'
        }
      },
      {
        id: 'optinEmail',
        value: email,
        model: 'email',
        placeholder: 'email_address',
        type: 'text',
        error: {
          field: 'email',
          message: 'email_addres_err'
        }
      },
      {
        id: 'optinPhone',
        value: mobile,
        model: 'phone',
        type: 'text',
        error: {
          field: 'mobile',
          message: 'mobile_number_err'
        }
      },
      {
        id: 'optinDob',
        value: dob,
        model: 'dob',
        placeholder: 'dob',
        type: 'date',
        error: {
          field: 'dob',
          message: 'dob_err'
        }
      },
      {
        id: 'optinAddress',
        value: address,
        model: 'address',
        placeholder: 'address',
        type: 'text',
        error: {
          field: 'address',
          message: 'address_err'
        }
      },
      {
        id: 'optinState',
        value: state,
        model: 'state',
        placeholder: 'state',
        type: 'text',
        error: {
          field: 'state',
          message: 'state_err'
        }
      },
      {
        id: 'optinPostcode',
        value: postcode,
        model: 'postcode',
        placeholder: 'postcode',
        type: 'text',
        error: {
          field: 'postcode',
          message: 'postcode_err'
        }
      },
      {
        id: 'optinCustomDesc',
        value: customDesc,
        model: 'customDesc',
        placeholder: 'comments',
        type: 'text',
        error: {
          field: 'customDescError',
          message: 'comments_error'
        }
      },
    ];

    let otherLCFields = [
      {
        id: 'optinMember',
        value: member,
        placeholder: 'comments',
        model: 'member',
        type: 'text',
      },
      {
        id: 'optinTncs',
        value: tnc,
        model: 'tnc',
        placeholder: 'confirm_adult',
        type: 'text',
        error: {
          field: 'tncError',
          message: 'terms_condition_18'
        }
      },
      {
        id: 'optinMarketing',
        value: marketing,
        model: 'optin',
        placeholder: 'confirm_adult',
        type: 'text'
      },
      {
        id: 'optinConfirmAdult',
        value: confirmAdult,
        model: 'confirmAdult',
        placeholder: 'confirm_adult',
        type: 'text',
        error: {
          field: 'confirmAdultError',
          message: 'confirm_adult_err'
        }
      },
    ];

    if (comp.isLCFOrderingEnabled) {
      leadCaptureFields = leadCaptureFields.concat(otherLCFields);
    }

    if (comp.otherOptins && comp.otherOptins.length > 0) {
      comp.otherOptins.forEach(function (oo) {
        if (oo.disabled || oo.deleted) {
          return;
        }
        oo.isCustom = true;
        oo.model = 'custom';
        // if (oo.index != null) {
        //   console.log('index', oo);
        //   that.leadCaptureFields[oo.index - 1] = oo;
        // } else {
        console.log('noindex', oo)
        leadCaptureFields.push(oo);
        // }
      });
    }

    if (!comp.isLCFOrderingEnabled) {
      leadCaptureFields = leadCaptureFields.concat(otherLCFields);
    }

    // leadCaptureFields.forEach((field, fieldIndex) => {
    //   if (!field.isCustom) {
    //     if (!comp[field.id] || comp[field.id] == 0 || comp[field.id] == null) {
    //       leadCaptureFields.splice(fieldIndex, 1);
    //     }
    //   }
    // })

    for (let i = leadCaptureFields.length - 1; i >= 0; i -= 1) {
      let field = leadCaptureFields[i];
      if (!field.isCustom) {
        if (!comp[field.id] || comp[field.id] == 0 || comp[field.id] == null) {
          leadCaptureFields.splice(i, 1);
        }
      }
    }

    let leadCaptureFieldsHolder = [];
    let leadCaptureFieldsSorted = [];

    if (comp.isLCFOrderingEnabled) {
      leadCaptureFields.forEach((field, fieldIndex) => {
        if (!field.isCustom) {
          if (comp[field.id] && comp[field.id] > 0 && comp[field.id] != null) {
            leadCaptureFieldsSorted.push([field.id, comp[field.id]]);
          }
        } else if (field.isCustom) {
          if (!field.disabled && !field.deleted) {
            leadCaptureFieldsSorted.push([field.id, field.index]);
          }
        }
      });

      leadCaptureFieldsSorted.sort(function (a, b) {
        return a[1] - b[1];
      });

      leadCaptureFieldsSorted.forEach((field, fieldIndex) => {
        var searchField = leadCaptureFields.find(function (lcf) {
          return lcf.id === field[0];
        });
        if (searchField) {
          leadCaptureFieldsHolder.push(searchField);
        }
      });

      leadCaptureFields = leadCaptureFieldsHolder;
    } else {
      leadCaptureFields = leadCaptureFields;
    }

    return (

      <div className={'tx ' + (noBorderRadius ? 'no-border-radius' : '')} id='app-page-3' style={{color: comp.primaryColor}}>
        {setCustomInputStyling(comp.primaryColor)}
        {/* <div className='header'>
          Thanks for voting!
        </div> */}
        {/* <div className='next-arrow-cont'>
          {!submitted &&
          <img src={nextArr} className='next-arrow' alt={''}/>}
        </div> */}
        <div className='thanks-cont'>
          <h1 className='thanks-cont-h1' style={{color: comp.primaryColor}}><Trans i18nKey="thanks_for_voting" /></h1>
          {comp.logoBg || (comp.sponsorsBg && comp.sponsorsTop) ? (
            <div>
              {comp.logoBg ? (
                <div className={'logos-cont'}>
                  <img src={comp.logoBg.file} className={'logo-image'} alt={''}/>
                </div>
              ) : null}
              {comp.sponsorsBg && comp.sponsorsTop ? (comp.sponsorsLink && comp.sponsorsLink != '') ? (
                <a href={comp.sponsorsLink} target="_blank">
                  <div className={'logos-cont'}>
                    <img src={comp.sponsorsBg.file} className={'logo-image sponsors'} alt={''}/>
                  </div>
                </a>
              ) : (
                <div className={'logos-cont'}>
                  <img src={comp.sponsorsBg.file} className={'logo-image sponsors'} alt={''}/>
                </div>
              ) : null}
            </div>
          ) : null}
          {(!submitted || !anyField) && !!comp.dataCaptureEnabled ? null :
            <p style={{color: comp.primaryColor}} className={'thanks-copy'} dangerouslySetInnerHTML={{__html: comp.thanksCopy}}/>}
          {!submitting && !submitted && anyField ? (
              <div className='optin-cont'>
                <h3 style={{color: comp.primaryColor}} className="lead-capture"
                  dangerouslySetInnerHTML={{__html: comp.lastPageCopy}}/>
                {/* removed this on Adam's request on Sep 18 2020 */}
                {/* <p style={{color: comp.primaryColor}}><Trans i18nKey="team_picker_description" /></p> */}

              {leadCaptureFields && leadCaptureFields.length > 0 ? (
                <div>
                  {leadCaptureFields
                    .filter(o => !o.disabled && !o.deleted)
                    .map((oo, otherIndex) => {
                      switch (oo.model) {
                        case "phone":
                          return (
                            <div className='optin-row'>
                              <div className='optin-col'>
                                {/* <FormControl
                                  type="text"
                                  value={mobile}
                                  placeholder={t('mobile_number')}
                                  onFocus={this.sendParentScrollMessage}
                                  onChange={(e) => this.handleChange('mobile', e)}
                                /> */}
                                <IntlTelInput
                                  containerClassName="intl-tel-input"
                                  inputClassName="form-control"
                                  value={mobile.value}
                                  preferredCountries={this.preferredCountries}
                                  defaultCountry={(comp.phoneDefaultCountry && comp.phoneDefaultCountry != null)
                                                  ? comp.phoneDefaultCountry : 'au'}
                                  placeholder={t('mobile_number')}
                                  separateDialCode={true}
                                  onPhoneNumberChange={(status, value, countryData, number) => this.handleMobileNumber({ status, value, countryData, number })}
                                  onSelectFlag={(value, countryData, number, status) => this.handleMobileNumber({ value, countryData, number, status })}
                                />
                                {errors.mobile ? (
                                  <HelpBlock><Trans i18nKey="mobile_number_err" /></HelpBlock>
                                ) : null}
                              </div>
                            </div>
                          )
                        case "customDesc":
                          return (

                            <div className='optin-row'>
                              <div className='optin-col'>
                                <FormControl
                                  componentClass='textarea'
                                  style={{ height: 120 }}
                                  placeholder={t('comments')}
                                  onFocus={this.sendParentScrollMessage}
                                  onChange={this.handleCustomDescriptionChange}
                                  name='customDesc'
                                  value={customDesc}
                                  maxLength='2000'
                                />
                                <div style={{ marginTop: 5 }}>{this.state.charLengthCustom}</div>
                              </div>
                            </div>
                          )
                        case "confirmAdult":
                          return (
                            <div className='optin-row'>
                              <div className=''>
                                <Checkbox id="optinConfirmAdult" className="custom-control custom-checkbox"
                                  checked={confirmAdult}
                                  onClick={this.handleAcceptConfirmAdult}
                                >
                                  <label class="custom-control-label" style={{ color: comp.primaryColor }}
                                    for="optinConfirmAdult">
                                    <Trans i18nKey="confirm_adult" />
                                  </label>
                                </Checkbox>
                                {errors.confirmAdult ? (
                                  <HelpBlock><Trans i18nKey="confirm_adult_err" /></HelpBlock>
                                ) : null}
                              </div>
                            </div>
                          )
                        case "optin":
                          return (
                            <div className='optin-row'>
                              <div className=''>
                                <Checkbox id="optinMarketingCopy" className="custom-control custom-checkbox"
                                  checked={marketing}
                                  onClick={this.handleAcceptMarketing}
                                >
                                  <label class="custom-control-label" style={{ color: comp.primaryColor }} for="optinMarketingCopy" dangerouslySetInnerHTML={{ __html: comp.optinMarketingCopy }} />
                                </Checkbox>
                              </div>
                            </div>
                          )
                        case "tnc":
                          return (
                            <div className='optin-row'>
                              <div className=''>
                                <Checkbox id="optinTncsCopy" className="custom-control custom-checkbox"
                                  checked={tnc}
                                  onClick={this.handleAcceptTnc}
                                >
                                  <label class="custom-control-label" style={{ color: comp.primaryColor }} for="optinTncsCopy" dangerouslySetInnerHTML={{ __html: comp.optinTncsCopy }} />
                                </Checkbox>
                                {errors.tnc ? (
                                  <HelpBlock><Trans i18nKey="terms_condition_err" /></HelpBlock>
                                ) : null}
                              </div>
                            </div>
                          )
                        case "dob":
                          return (
                            <div className="optin-row">
                              <div className='text-center' style={{ color: comp ? comp.primaryColor : '' }}>
                                <Trans i18nKey="dob" />
                              </div>
                              <div className='optin-col'>
                                <FormControl
                                  className='date_of_birth'
                                  type='date'
                                  placeholder="dd/mm/yyyy"
                                  name='dob'
                                  onFocus={this.sendParentScrollMessage}
                                  onChange={(e) => this.handleChange('dob', e)}
                                  value={dob}
                                />
                                {errors.dob ? (
                                  <HelpBlock><Trans i18nKey="dob_err" /></HelpBlock>
                                ) : null}
                              </div>
                            </div>
                          )
                        case "member":
                          return (
                            <div>
                              <div className='optin-row'>
                                <div className='optin-col text-left'>
                                  <div className='fieldLabel' style={{ color: comp.primaryColor }}>{comp.optinMemberLabel}</div>
                                  <FormGroup>
                                    <Radio id="membershipYes" className="custom-control custom-radio custom-control-inline" name="radioGroup" onClick={() => this.selectMembership(true)} inline>
                                      <label class="custom-control-label" style={{ color: comp.primaryColor }} for="membershipYes"><Trans i18nKey="yes" /></label>
                                    </Radio>{' '}
                                    <Radio id="membershipNo" className="custom-control custom-radio custom-control-inline" name="radioGroup" onClick={() => this.selectMembership(false)} inline>
                                      <label class="custom-control-label" style={{ color: comp.primaryColor }} for="membershipNo"><Trans i18nKey="no" /></label>
                                    </Radio>
                                  </FormGroup>
                                </div>
                              </div>
                              {comp.optinMember && member === true ? (
                                <div className='optin-row'>
                                  <div className='optin-col'>
                                    <FormControl
                                      type="text"
                                      value={memberNo}
                                      placeholder={comp.optinMemberYesCopy}
                                      onFocus={this.sendParentScrollMessage}
                                      onChange={this.memberYes}
                                    />
                                  </div>
                                </div>
                              ) : null}
                              {comp.optinMember && member === false ? (
                                <div className='optin-row'>
                                  <div className='optin-col text-left'>
                                    <div class="fieldLabel" style={{ color: comp.primaryColor }}>{comp.optinMemberNoCopy}</div>
                                    <FormGroup>
                                      <Radio id="optinMemberNoCopyYes" className="custom-control custom-radio custom-control-inline" name="MemberNoGroup" onClick={() => this.memberNo(true)} inline>
                                        <label class="custom-control-label" style={{ color: comp.primaryColor }} for="optinMemberNoCopyYes"><Trans i18nKey="yes" /></label>
                                      </Radio>{' '}
                                      <Radio id="optinMemberNoCopyNo" className="custom-control custom-radio custom-control-inline" name="MemberNoGroup" onClick={() => this.memberNo(true)} inline>
                                        <label class="custom-control-label" style={{ color: comp.primaryColor }} for="optinMemberNoCopyNo"><Trans i18nKey="no" /></label>
                                      </Radio>
                                    </FormGroup>
                                  </div>
                                </div>
                              ) : null}
                            </div>
                          )
                        case "custom":
                          return (
                            <div className="optin-row">
                              {this.renderCustomFieldsActual(oo, others, otherIndex, comp, t)}
                              {errors.customMandatoryOptin && oo.hasError ? (
                                  <HelpBlock className='text-center'><Trans i18nKey="field_required" /></HelpBlock>
                              ) : null}
                            </div>
                          )
                        default:
                          return (
                            <div className="optin-row">
                              <div className="optin-col">
                                <FormControl
                                  type={oo.type}
                                  value={oo.value}
                                  placeholder={t(oo.placeholder)}
                                  onFocus={this.sendParentScrollMessage}
                                  onChange={e => this.handleChange(oo.model, e)}
                                />
                                {errors[oo.error.field] ? (
                                  <HelpBlock>
                                    <Trans i18nKey={oo.error.message} />
                                  </HelpBlock>
                                ) : null}
                              </div>
                            </div>
                          )
                      }
                    })}
                </div>
              ) : null}
                
                <div className='optin-row last'>
                  <div className=''>
                    <div className="primary submit-optin"
                        //  style={{backgroundColor: comp.buttonColor}}
                        style={{backgroundColor: comp.buttonColor, color: comp.secondaryColor}}
                        onClick={this.handleSubmit}
                    >
                    
                    {comp.submitCopy?comp.submitCopy:<Trans i18nKey="submit" />}
                    </div>
                  </div>
                </div>
              </div>
            ) :
            (
              submitted || !anyField ?
                null :
                (<div style={{color: comp.primaryColor}} className={'thanks-for-optin'}><Trans i18nKey="recording_details" /></div>)
            )
          }
        </div>
        {submitted ? (
          <div className="shares-cont">
            {comp.marketingButtons.map(mb => {
              if (mb && mb.enabled) {
                return <div className="marketingButtonCont">
                    <div className="marketingButtonContInner">
                      <a className="primary submit-optin"
                        style={{backgroundColor: comp.buttonColor, color: comp.secondaryColor}}
                        target={mb.target}
                        href={mb.url}>{mb.label}</a>
                    </div>
                  </div>;
                }
              }
            )}

            {(comp && comp.isViralSharingEnabled && comp.viralBoosters && comp.viralBoosters.length) ?
              <div className="row">
                  <div className="col-sm-12">
                      <div className="v-booster-section row">
                          {comp.drawCopy && comp.drawCopy != '' ? <div className="row v-b-info">
                              <span
                                  style={{
                                      color: comp.primaryColor ? comp.primaryColor : '#FFFFFF'
                                  }}
                                  dangerouslySetInnerHTML={{__html: comp.drawCopy}}>
                              </span>
                          </div> : ''}
                          {comp.viralBoosters.map((vb, vbIndex) =>
                              <div className="v-booster" style={{
                                  backgroundColor: vb.buttonColor ? vb.buttonColor : '#808080',
                                  color: vb.textColor ? vb.textColor : '#FFFFFF',
                              }} onClick={() => this.triggerVBooster(vb)}
                                  key={vbIndex}>
                                  {vb.image ? <img src={vb.image.file} /> : ''}
                                  <span className="v-b-text">{vb.ctaText}</span>
                                  {/* <span className="v-b-p-added">
                                          <img src="https://benchvote-media-assets.s3.ap-southeast-2.amazonaws.com/common-images/icons/tick_green.png" />
                                      </span> */}
                              </div>
                          )}
                      </div>
                  </div>
              </div>
            : '' }

            {/* {this.isSocialNetworkEnabledForCompetition(1) ? (
              <div className="share-btn faceShare"
                   onClick={() => this.handleFacebookShare(this.props.competition, this.props.vote.payload)}>
                <i className="fa fa-2x fa-facebook" aria-hidden="true"/>
                <div className="text-nowrap"><Trans i18nKey="share" /></div>
              </div>
            ) : null} */}
            {/* {this.isSocialNetworkEnabledForCompetition(2) ? (
              <div className="share-btn twitterShare"
                   onClick={() => this.handleTwitterShare(this.props.competition, this.props.vote.payload)}>
                <i className="fa fa-2x fa-twitter" aria-hidden="true"/>
                <div className="text-nowrap"><Trans i18nKey="share" /></div>
              </div>
            ) : null} */}
            {this.props.vote && this.props.vote.share && this.props.vote.share.submitting ? 
              (<div className="text-nowrap loading-block"><Trans i18nKey="loading" /></div>)
              : null}
          </div>) : null}
       
        { submitted && this.props && this.props.competition.shareEnabled ?
          <div className='social-share-multi'>
             <IoMdArrowDropleft onClick={()=>this.handleChangeShare('previous')} style={{cursor:'pointer'}} size={50} color="#fff" fill={comp.buttonColor}/>
             <div className='social-share-wrapper' ref={this.socialShareRef}>
                <div className='wrapper' > <FacebookShareButton 
                  url={socialShareUrl} 
                  quote={socialShareTitle} 
                  size={32} round={true} >
                    <FacebookIcon size={32} round={true} />
                    </FacebookShareButton>
                    <TwitterShareButton 
                    url={socialShareUrl} 
                    title={socialShareTitle} 
                   >
                      <TwitterIcon size={32} round={true}/>
                    </TwitterShareButton>
                </div>
                <div className='wrapper' >
                    <CustomShare className="messenger" variant="facebook-messenger" config={{url:socialShareUrl}}>
                      <FacebookMessengerIcon size={32} round={true} />
                    </CustomShare>
                    <WhatsappShareButton 
                  url={socialShareUrl} 
                  title={socialShareTitle} 
                   >
                    <WhatsappIcon size={32} round={true} />
                    </WhatsappShareButton>
                </div>
                <div className='wrapper' >
                  <CustomShare className="sms" variant="sms" config={{text: socialShareTitle+' ',url:socialShareUrl,
                }}><FaSms  size={20}  style={{color:'#3B5997', fill:'#ffffff'}}  /></CustomShare>
                 <EmailShareButton 
                  url={socialShareUrl} 
                  subject={socialShareTitle} 
                  body={socialShareDescription} >
                    <EmailIcon size={34} round={true}/>
                    </EmailShareButton>
                </div>
                <div className='wrapper' >
                  {/* <LinkedinShareButton 
                  url={socialShareUrl} 
                  title={socialShareTitle} 
                  summary={socialShareDescription} 
                  > 
                  <LinkedinIcon size={32} round={true} />
                  </LinkedinShareButton> */}
                  <RedditShareButton 
                  url={socialShareUrl} 
                  title={socialShareTitle} 
                  description={socialShareDescription} >
                    <RedditIcon size={32} round={true} />
                    </RedditShareButton>
                    <CustomShare className="skype" config={{url: socialShareUrl,
                text: socialShareTitle}} variant="skype"><FaSkype  size={20} style={{color:'#3B5997', fill:'#ffffff'}}/></CustomShare>
                </div>
                <div className='wrapper' >
                  <PinterestShareButton 
                  url={socialShareUrl} 
                  title={socialShareTitle} 
                  description={socialShareDescription} 
                  media={socialShareMedia} 
                  >
                    <PinterestIcon size={32} round={true} />
                    </PinterestShareButton>
                    <CustomShare className="wordpress" variant="wordpress" config={{url:socialShareUrl,
                text: socialShareTitle,
                media:socialShareMedia }}><FaWordpress  size={20}  style={{color:'#3B5997', fill:'#ffffff'}}  /></CustomShare>
                </div>
                <div className='wrapper' > 
                  <CustomShare className="flipboard" variant="flipboard" config={{url:socialShareUrl,
                text: socialShareTitle}}><FaFlipboard  size={20}  style={{color:'#3B5997', fill:'#ffffff'}}/></CustomShare>
                 <TumblrShareButton 
                  url={socialShareUrl}
                  title={socialShareTitle} 
                  caption={socialShareDescription} >
                    <TumblrIcon size={36} round={true} />
                    </TumblrShareButton>
                </div>
                <div className='wrapper' >
                    <CustomShare className="buffer" variant="buffer" config={{url:socialShareUrl,
                text: socialShareTitle,
                media:socialShareMedia }}><FaBuffer size={18}  style={{color:'#3B5997', fill:'#ffffff'}}  /></CustomShare>
                 <PocketShareButton 
                  url={socialShareUrl} 
                  title={socialShareTitle} 
                  description={socialShareDescription} >
                    <PocketIcon size={32} round={true} />
                  </PocketShareButton>
                </div>
                {/* <div className='wrapper' >
                 
                </div> */}
              </div>

              <IoMdArrowDropright onClick={()=>this.handleChangeShare('next')} style={{cursor:'pointer'}} size={50} color="#fff" fill={comp.buttonColor}/>

   </div>:null}

        {/* dynamic render of voted players */}
        {dynamicSubmitting ? (<div className={"text-nowrap loading-block " + (submitted ? '' : 'dynamic-render-hide')}><Trans i18nKey="loading" /></div>) 
          : dynamicRenderUrl && dynamicRenderUrl != ''
            ? (<div className={"dynamic-render " + (submitted ? '' : 'dynamic-render-hide')}>
                <img src={dynamicRenderUrl} className={'dynamic-render-image'} alt={''}/>
                <a target="_blank" className={"dynamic-render-button"}
                    style={{
                        backgroundColor: comp.buttonColor,
                        color: comp.secondaryColor
                    }}
                    href={dynamicRenderUrl} download="share-image.jpg">
                        <Trans i18nKey="download_image" />
                </a>
              </div>)
            : null}

        {submitted && this.props.competition.isVoteDataVisualizationEnabled ?
          <div style={{textAlign: 'center'}}>
            <PlayersStatistics idCompetition={this.props.competition.id}
                               showInPercents={this.props.competition.isVoteDataVisualisationInPercents}
                               fontColor={this.props.competition.primaryColor}
                               backgroundColor={this.props.competition.secondaryColor}/>
          </div> : null}

        <Footer
          tncs={this.props.competition.tncs}
          privacypolicy={this.props.competition.privacypolicy}
          showMadeWithBv={this.props.competition.showMadeWithBv} />

      </div>
    );
  }
}

//-------------------------------------------------------------------------
//-------------------- Mapping store to App's props ----------------------
//-------------------------------------------------------------------------

const
  mapStateToProps = (state, ownProps) => {

    return {
      ...ownProps,
      optin: state.default.bulldogs.optin,
      competition: state.default.bulldogs.competition,
      vote: state.default.bulldogs.vote,
      tracking: state.default.tracking,
      locale: state.default.locale,
      dynamicRender: state.default.bulldogs.dynamicRender
    }
  }

const
  mapDispatchToProps = dispatch => {
    return {
      dispatch
    }
  }

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Thanks));
